export const AcatsBrokerageFirms = [
  {
    name: 'TD Ameritrade',
    dtc: '0188',
    img: 'td-ameritrade.svg',
    id: 'tdAmeritrade'
  },
  {
    name: 'Edward Jones',
    dtc: '0057',
    img: 'edward-jones.svg',
    id: 'edwardJones'
  },
  {
    name: 'Fidelity',
    dtc: '0226',
    img: 'fidelity.svg',
    id: 'fidelity'
  },
  {
    name: 'Wells Fargo',
    dtc: '0141',
    img: 'wells-fargo.svg',
    id: 'wellsFargo'
  },
  {
    name: 'Etrade',
    dtc: '0385',
    img: 'etrade.svg',
    id: 'eTrade'
  },
  {
    name: 'Vanguard',
    dtc: '0062',
    img: 'vanguard.svg',
    id: 'vanguard'
  },
  {
    name: 'Charles Schwab',
    dtc: '0164',
    img: 'schwab.svg',
    id: 'charlesSchwab'
  },
  {
    name: 'Merrill Lynch',
    dtc: '0671',
    img: 'merrill-lynch.svg',
    id: 'merrillLynch'
  },
  {
    name: 'Interactive Brokers',
    dtc: '0534',
    img: 'interactive-brokers.svg',
    id: 'interactiveBrokers'
  },
  {
    name: 'Folio Investments',
    dtc: '0728',
    id: 'folioInvesments'
  },
  {
    name: 'Morgan Stanley',
    dtc: '0015',
    id: 'morganStanley'
  },
  {
    name: 'JP Morgan Chase',
    dtc: '0352',
    id: 'jpMorganChase'
  },
  {
    name: 'LPL',
    dtc: '0075',
    id: 'lpl'
  },
  {
    name: 'Raymond James',
    dtc: '0725',
    id: 'raymondJames'
  },
  {
    name: 'Citigroup',
    dtc: '0418',
    id: 'citigroup'
  },
  {
    name: 'RBC Capital Markets',
    dtc: '0235',
    id: 'rbcCapitalMarkets'
  },
  {
    name: 'Bank of America',
    dtc: '0671',
    id: 'bankOfAmerica'
  },
  {
    name: 'Metlife',
    dtc: '7131',
    id: 'metlife'
  },
  {
    name: 'Tradestation',
    dtc: '0271',
    id: 'tradestation'
  },
  {
    name: 'ChoiceTrade',
    dtc: '0873',
    id: 'choiceTrade'
  },
  {
    name: 'sogo',
    dtc: '0158',
    id: 'sogo'
  },
  {
    name: 'Lightspeed',
    dtc: '8199',
    id: 'lightspeed'
  },
  {
    name: 'Betterment',
    dtc: '0158',
    id: 'betterment'
  },
  {
    name: 'Wealthfront',
    dtc: '0235',
    id: 'wealthfront'
  },
  {
    name: 'Robinhood',
    dtc: '6769'
  },
  {
    name: 'Pershing',
    dtc: '0443'
  },
  {
    name: 'American Enterprise Investment Services',
    dtc: '0756'
  },
  {
    name: 'UBS Financial Services',
    dtc: '0221'
  },
  {
    name: 'Hilltop Securities',
    dtc: '0279'
  },
  {
    name: 'Webull',
    dtc: '0158'
  },
  {
    name: 'Sofi',
    dtc: '0158'
  }
];
